import type { RetryConfig } from '@/shared/types/api';
import { DEFAULT_RETRY_CONFIG } from '@/shared/types/api';

export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function calculateBackoff(
  attempt: number,
  config: RetryConfig = DEFAULT_RETRY_CONFIG
): number {
  const exponentialDelay = config.baseDelayMs * Math.pow(2, attempt);
  const jitter = exponentialDelay * Math.random() * 0.25;
  return Math.min(exponentialDelay + jitter, config.maxDelayMs);
}

export function shouldRetry(
  status: number | undefined,
  code: string | undefined,
  currentAttempt: number,
  config: RetryConfig = DEFAULT_RETRY_CONFIG
): boolean {
  if (!config.enabled) {
    return false;
  }
  if (currentAttempt >= config.maxRetries) {
    return false;
  }
  if (code && config.retryableCodes.includes(code)) {
    return true;
  }
  if (status !== undefined && config.retryableStatuses.includes(status)) {
    return true;
  }
  return false;
}
